import type { OutputReference } from "@smartsuite/automation-engine-api";

import type { LeftSource } from "./types";

/**
 * Whether the stored left-side reference points at this source -- trigger by
 * triggerId, action by instanceId + actionId (mirrors
 * resolveReferencedConditionField). Gates the field-list highlight so a field
 * only lights up in the list of the source it was actually picked from
 * (STR-14248): trigger and actions over the same table expose identical
 * conditionFieldIds, so the id alone cannot scope the highlight.
 */
export const matchesLeftSource = (
  source: LeftSource,
  outputReference: OutputReference | undefined,
): boolean => {
  if (outputReference === undefined) return false;
  const reference = outputReference.source;

  if (
    reference.oneofKind === "triggerReference" &&
    source.reference.oneofKind === "triggerReference"
  ) {
    return (
      reference.triggerReference.triggerId ===
      source.reference.triggerReference.triggerId
    );
  }

  if (
    reference.oneofKind === "actionReference" &&
    source.reference.oneofKind === "actionReference"
  ) {
    return (
      reference.actionReference.instanceId ===
        source.reference.actionReference.instanceId &&
      reference.actionReference.actionId ===
        source.reference.actionReference.actionId
    );
  }

  return false;
};
